<template>
    <el-container class="pilotni-vycvik">
      <div class="nabidky-wrapper">

      <div class="nabidky-carousel">
        <el-carousel>
          <el-carousel-item v-for="item in photos_url" :key="item">
            <img :src="item" loading="lazy">
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="nabidky-content">
        <h1>Pilotní výcvik</h1>
        <p>
          Provádíme výcvik pro získání dvou kategorií pilotního oprávnění:
        </p>
        <div style="display: flex; flex-direction: row;">
          <el-button class="btn-el" @click="router.push('/ull')" >ULL</el-button>
          <el-button class="btn-el" @click="router.push('/spl')" >SPL</el-button>
        </div>
      </div>
      
    </div>
    </el-container>
</template>

<script>
import { useRouter } from 'vue-router'



export default {
  name: "VyhlidkoveLety",
  setup(){
    const router = useRouter();
    let photos_url = [];

    for(let img_n of [10, 19, 21, 25]){//[10, 17, 19, 21, 25]
      photos_url.push(require("../../src/assets/photos/img"+String(img_n)+".jpg"))
      img_n
    }

    return {router, photos_url}
  }
}
</script>


<style scoped>

.btn-el{
  width: 225px;
  /* max-width: 50%; */
  background: #ffffff;
  color: #495052;
  border-width: 1px;
  font-size: 17px;
}

.btn-el:hover{
  background: #74949c;
  color: #ffffff;
  border-color: #74949c;;
  
  
}


.pilotni-vycvik {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 100%;
  /* background: linear-gradient(180deg, #dee8f1,#ffffff, #ffffff); */
  /* background: linear-gradient(180deg, #e5eaee, #ffffff,#ffffff); */
  background: #ebeef0;
  padding-top: 20px;
  padding-bottom: 20px;
}

.nabidky-wrapper{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap-reverse;
  overflow: hidden;
  width: 100%;
}

.nabidky-content{
  margin: 20px;
  width: 50%;
  max-width: 600px;
  flex-grow: 1;
}

.nabidky-carousel{
  margin: 20px;
  max-width: 600px;
  min-width: 410px;
  flex-grow: 1;
}

.el-carousel__item img {
  max-width: 100%;
}

</style>